import http from "../../http-common";

class TeacherFeedbackService {
  getAll() {
    return http.get("/feedbacktc");
  }

  getById(id) {
    return http.get(`/feedbacktc/${id}`);
  }
  deleteById(id) {
    return http.get(`/feedbacktc/delete/${id}`);
  }
  // searchFeedBack(hiddenStatus, schoolUnread, dateStartEnd, feedbackTitle) {
  //   return http.get(`/feedbacktc/search?hiddenStatus=${hiddenStatus}&schoolUnread=${schoolUnread}&dateStartEnd=${dateStartEnd}&feedbackTitle=${feedbackTitle}`);
  // }
  searchFeedBack(pageNumber, maxPageItem, hiddenStatus, schoolUnread, dateStartEnd, feedbackTitle, confirmStatus) {
    return http.get(`/feedbacktc/search?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&hiddenStatus=${hiddenStatus}&schoolUnread=${schoolUnread}&dateStartEnd=${dateStartEnd}&feedbackTitle=${feedbackTitle}&confirmStatus=${confirmStatus}`);
  }
  update(id, data) {
    return http.put(`/feedbacktc/${id}`, data);
  }
  updateRead(data) {
    return http.put(`/feedbacktc/update-many-read`, data);
  }
}
export default new TeacherFeedbackService();